module.exports = __webpack_public_path__ + "static/media/icon_white.e88036b8.svg";